<template>
  <div>
    <div v-for="({ label, input, tooltip }, i) in questions" :key="label + i">
      <div
        v-if="
          !input.show_on ||
            (input.show_on && input.show_on === $root.countries.selected)
        "
        :class="`q-and-a p-6 ${i % 2 === 0 ? 'bg-lblue' : ''}`"
      >
        <div class="question">
          <div class="u-h2 font-normal">
            {{ label }}
            <Tooltip v-if="tooltip && tooltip.heading" v-bind="tooltip" />
          </div>
        </div>
        <div class="answer">
          <vue-numeric
            v-if="input.type === 'currency'"
            :currency="$root.currency"
            v-model="$root[input.name]"
            class="text-center font-semibold text-24px"
          />
          <vue-numeric
            currency="%"
            v-if="input.type === 'percentage'"
            currency-symbol-position="suffix"
            :min="0"
            :max="100"
            v-model="$root[input.name]"
            class="text-center font-semibold text-24px"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Tooltip from '@/components/Tooltip.vue';
export default {
  components: { Tooltip },
  props: ['questions'],
  data: () => ({}),
  computed: {},
  mounted() {
    this.questions.forEach(q => {
      const name = q.input.name;
      const placeholderVal = +q.input.placeholder;
      if (!isNaN(placeholderVal) && this.$root[name] !== placeholderVal) {
        this.$root[name] = placeholderVal
      }
    })
  }
};
</script>

<style></style>
